import {Routes} from '@angular/router';
import {guestGuard} from '../auth/auth.guard';

export const authChildRoutes: Routes = [
  {
    path: 'mailings/unsubscribe', data: {screenKey: 'MailingUnsubscribe'},
    loadComponent: () => import('../mailings/mailing-unsubscribe.page').then(m => m.MailingUnsubscribePage),
  },
  {

    data: {screenKey: 'Login'},
    path: 'login',
    canActivate: [guestGuard],
    loadChildren: () => import('../login/login.module').then(m => m.LoginPageModule),
  },
  {

    data: {screenKey: 'Register'},
    path: 'register',
    canActivate: [guestGuard],
    loadChildren: () => import('../register/register.module').then(m => m.RegisterPageModule),
  },
  {

    data: {screenKey: 'ForgotPassword'},
    path: 'forgot-password',
    canActivate: [guestGuard],
    loadChildren: () => import('../forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule),
  },
  {

    data: {screenKey: 'ResetPassword'},
    path: 'reset-password',
    canActivate: [guestGuard],
    loadChildren: () => import('../reset-password/reset-password.module').then(m => m.ResetPasswordPageModule),
  },
  {

    data: {screenKey: 'VerifyEmail'},
    path: 'verify-email',
    loadChildren: () => import('../verify-email/verify-email.module').then(m => m.VerifyEmailPageModule),
  },
  {

    data: {screenKey: 'Logout'},
    path: 'logout',
    loadChildren: () => import('../logout/logout.module').then(m => m.LogoutPageModule),
  },
];
